export const SYSTEM_USER_GROUPS = [
  { key: 'user', label: 'User' },
  { key: 'retail_customer', label: 'Retail Customer' },
  { key: 'vendor', label: 'Vendor' },
  { key: 'client', label: 'Client' },
  { key: 'supplier', label: 'Supplier' },
  { key: 'business_customer', label: 'Business Customer' },
] as const

const canonicalLabelByKey = new Map<string, string>(SYSTEM_USER_GROUPS.map((entry) => [entry.key, entry.label]))

export function normalizeOrgUserGroupKey(value: string | null | undefined): string {
  const normalized = String(value || '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '')

  if (!normalized) {
    return ''
  }

  if (normalized === 'admin') {
    return 'user'
  }
  if (normalized === 'users') {
    return 'user'
  }
  if (normalized === 'customer') {
    return 'retail_customer'
  }
  if (normalized === 'customers') {
    return 'retail_customer'
  }
  if (normalized === 'retail_customers') {
    return 'retail_customer'
  }
  if (normalized === 'businesscustomer') {
    return 'business_customer'
  }
  if (normalized === 'businesscustomers' || normalized === 'business_customers') {
    return 'business_customer'
  }
  if (normalized === 'suppliers') {
    return 'supplier'
  }
  if (normalized === 'vendors') {
    return 'vendor'
  }
  if (normalized === 'clients') {
    return 'client'
  }

  return normalized
}

export function isSystemOrgUserGroup(group: { title?: string | null; unique_code?: string | null; is_system?: boolean }): boolean {
  if (group.is_system) {
    return true
  }

  const keyFromCode = normalizeOrgUserGroupKey(group.unique_code)
  if (canonicalLabelByKey.has(keyFromCode)) {
    return true
  }

  const keyFromTitle = normalizeOrgUserGroupKey(group.title)
  return canonicalLabelByKey.has(keyFromTitle)
}

export function getOrgUserGroupLabel(title: string | null | undefined, fallback: string): string {
  const normalizedTitle = normalizeOrgUserGroupKey(title)
  if (!normalizedTitle) {
    return fallback
  }

  return canonicalLabelByKey.get(normalizedTitle) || String(title).trim()
}